// react
import React from "react"
// app
import AutoComplete from "containers/AutoComplete"


export default ({
    onCitizenshipChange
}) =>
    <div className="clearfix">
        <h4>Add Citizenship</h4>
        <AutoComplete
            autoFocus={ true }
            table="country"
            label="Citizenship"
            onChange={ onCitizenshipChange }
        />
    </div>


/** WEBPACK FOOTER **
 ** ./src/components/person/Citizenship/add.js
 **/